export default __webpack_public_path__ + "static/media/treehouse.28756aa1.svg";